import type { SliceStateFromReducer } from 'shared/types';

import { setAvailableBanks, type offersSlice } from './offers.slice';

export type TOffersStateFromReducer = SliceStateFromReducer<typeof offersSlice>;

type CalculateAvailableBankThunkProps<TResult> = {
  successCallback: (filteredAvailableBanksCount: number) => Promise<TResult>;
  ids: string[];
};

export const calculateAvailableBankThunk =
  <TResult>({ successCallback, ids }: CalculateAvailableBankThunkProps<TResult>) =>
  async (dispatch: Dispatch, getState: () => { offers: TOffersStateFromReducer['offers'] }) => {
    const { availableBanks } = getState().offers;
    const filteredAvailableBanks = availableBanks?.filter((bankId) => !ids.includes(bankId));
    if (filteredAvailableBanks?.length !== availableBanks?.length) {
      await dispatch(setAvailableBanks(filteredAvailableBanks));
    }
    const data = await successCallback(filteredAvailableBanks?.length);

    return data;
  };
